/* eslint-disable import/no-dynamic-require */
import React, { PropsWithChildren } from 'react'
import { RawIntlProvider, createIntlCache, createIntl } from 'react-intl'

// types
import { AvailableLanguagesType, ContextProps } from '../types/types'

// utils
import { setIntl } from './intl'
import { parseLanguageAndRegionFromLocale } from './helper'
import { AVAILABLE_LANGUAGES, DEFAULT_LOCALE } from '../appDefaults'

type LocalizationData = {
	locale: string
	messages: Record<string, string>
}

const cache = createIntlCache()

const createIntInstance = (data: LocalizationData) => {
	const intlInstance = createIntl(
		{
			locale: data.locale,
			messages: data.messages
		},
		cache
	)

	setIntl(intlInstance)

	return intlInstance
}

const LanguageProvider = ({ children, ...props }: PropsWithChildren<ContextProps>) => {
	const { locale } = props // locale here is 'sk-SK', 'cs-CZ', etc.
	let language = parseLanguageAndRegionFromLocale(locale).language || locale.substring(0, 2)

	if (!AVAILABLE_LANGUAGES.includes(language as AvailableLanguagesType)) {
		language = DEFAULT_LOCALE
	}

	// eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
	const messages = require(`../../public/locales/${language}/messages.json`)

	return <RawIntlProvider value={createIntInstance({ messages, locale: language })}>{React.Children.only(children)}</RawIntlProvider>
}

export default LanguageProvider
